import React from "react";

import { useSelector } from "react-redux";

// Components

import FormInputGroup from "../../../../UI/FormInputGroup/FormInputGroup";
import TextInput from "../../../../UI/FormInput/TextInput";
import DropDownInput from "../../../../UI/FormInput/DropDownInput";
import MaskInput from "../../../../UI/FormInput/MaskInput";
import CurrencyInput from "../../../../UI/FormInput/CurrencyInput";
import CalendarInput from "../../../../UI/FormInput/CalendarInput";

// Utilities

import { formatDropDownOptions } from "../../../../../utilities/helper-functions";

// Constants

import { MAX_CURRENCY_INPUT_DIGITS, PASSPORT_MASK_FORMAT, RIF_MASK_FORMAT } from "../../../../../config/constants";

export default function Employee({formik}) {
  const dropDownOptions = useSelector((state) => state.options.dropDownOptions);
  return (
    <>
      <FormInputGroup>

        <CalendarInput
          formik={formik}
          fieldName={`jobReferences.empleo.fechaConsIng`}
          label={"Fecha de la constancia de ingresos"}
          maxDate={new Date()}
          isRequired={true}
        />

        <DropDownInput
          formik={formik}
          fieldName={`jobReferences.empleo.rifType`}
          label={"Tipo RIF"}
          options={formatDropDownOptions(dropDownOptions?.data?.jobIdentificationTypes)}
          isRequired={true}
        />

        <MaskInput
          formik={formik}
          fieldName={`jobReferences.empleo.rif`}
          label={"RIF"}
          mask={formik.values.jobReferences?.empleo?.rifType === 'P' ? PASSPORT_MASK_FORMAT : RIF_MASK_FORMAT}
          isRequired={true}
        />

        <DropDownInput
          formik={formik}
          fieldName={`jobReferences.empleo.moneda`}
          label={"Moneda"}
          options={formatDropDownOptions(dropDownOptions?.data?.currencies)}
          isRequired={true}
        />

        <CurrencyInput
          formik={formik}
          fieldName={`jobReferences.empleo.sueldoMensual`}
          label={"Sueldo"}
          isRequired={true}
          max={MAX_CURRENCY_INPUT_DIGITS}
        />

        <DropDownInput
          formik={formik}
          fieldName={`jobReferences.empleo.tipoContrato`}
          label={"Tipo de Contrato"}
          options={formatDropDownOptions(dropDownOptions?.data?.typeOfContracts)}
          isRequired={true}
        />

        <TextInput
          formik={formik}
          fieldName={`jobReferences.empleo.nombreEmpresa`}
          label={"Nombre de la Empresa"}
          maxLength={80}
          isRequired={true}
        />

        <TextInput
          formik={formik}
          fieldName={`jobReferences.empleo.cargo`}
          label={"Cargo que desempeña"}
          maxLength={80}
          isAlphabetic
          isRequired={true}
        />

        <CalendarInput
          formik={formik}
          fieldName={`jobReferences.empleo.fechaIngreso`}
          label={"Fecha de ingreso"}
          maxDate={new Date()}
          isRequired={true}
        />

        <DropDownInput
          formik={formik}
          fieldName={`jobReferences.empleo.rol`}
          label={"Rol"}
          options={formatDropDownOptions(dropDownOptions?.data?.companyRoles)}
          isRequired={true}
        />

        <TextInput
          formik={formik}
          fieldName={`jobReferences.empleo.email`}
          label={"Dirección Email"}
          maxLength={80}
        />

        <TextInput
          formik={formik}
          fieldName={`jobReferences.empleo.ramo`}
          label={"Ramo del negocio"}
          maxLength={64}
          isRequired={true}
        />

        <DropDownInput
          formik={formik}
          fieldName={`jobReferences.empleo.otraMoneda`}
          label={"Otra moneda"}
          options={formatDropDownOptions(dropDownOptions?.data?.currencies)}
          isRequired={true}
        />

        <CurrencyInput
          formik={formik}
          fieldName={`jobReferences.empleo.sueldoBonificacion`}
          label={"Otros ingresos por Bonificación"}
          max={MAX_CURRENCY_INPUT_DIGITS}
        />

      </FormInputGroup>

    </>
  );
}
